export const ROLES = {
  DIRECTOR: 'Director',
  ADMINISTRATOR: 'Administrator',
  ANALYST: 'Analyst',
  USER: 'User',
  VIEWER: 'Viewer',
}
